// merchantHomeHref is still exported from merchantNavAccess for MerchantSectionGate

export function branchIsLive(status?: string | null): boolean {
  return (status ?? '').toUpperCase() === 'ACTIVE';
}

/** True when no branch has reached ACTIVE status yet (07-07 pre-live). */
export function merchantIsPreLive(
  branches: Array<{ status?: string | null }> | undefined,
): boolean {
  return !branches?.some((branch) => branchIsLive(branch.status));
}

/** 07-07 — checklist is home until the merchant has a live branch. */
export function merchantHomePathFromBranches(
  branches: Array<{ status?: string | null }> | undefined,
  _roles: readonly string[],
): string {
  if (merchantIsPreLive(branches)) return '/onboarding-checklist';
  return '/order-board';
}
